import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter, Link } from 'react-router-dom'
import { logout } from '../../auth/actions'
import { getIsLoggedIn } from 'Features/auth/selectors'
import { Menu, Container, Dropdown } from 'semantic-ui-react'
import { PREFIX } from 'Lib'
// const trigger = (
//     <span><Icon name='user' /></span>
// )

const NoAuthHeader = () => (
    <div>

    </div>
)

const AuthHeader = ({ logout }) => (
    <Container>
        <Menu secondary>
            <Menu.Item as={Link} to={`${PREFIX}/`}>Home</Menu.Item>
            <Menu.Item style={{ minWidth: '150px' }}>
                <Dropdown item text='Master Data' style={{ width: '100%' }} >
                    <Dropdown.Menu>
                        <Dropdown.Item as={Link} to={`${PREFIX}/user/local`}>Users</Dropdown.Item>
                        <Dropdown.Item as={Link} to={`${PREFIX}/departments`}>Departments</Dropdown.Item>
                        <Dropdown item text='Locations'>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to={`${PREFIX}/room`}>Room</Dropdown.Item>
                                <Dropdown.Item as={Link} to={`${PREFIX}/roomtype`}>Room Type</Dropdown.Item>
                                <Dropdown.Item as={Link} to={`${PREFIX}/roomformat`}>Room Format</Dropdown.Item>
                                <Dropdown.Item as={Link} to={`${PREFIX}/floors`}>Floors</Dropdown.Item>
                                <Dropdown.Item as={Link} to={`${PREFIX}/building`}>Buildings</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown item text='Beverage'>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to={`${PREFIX}/fbsCategory`}>Beverage Category</Dropdown.Item>
                                <Dropdown.Item as={Link} to={`${PREFIX}/fbs`}>Beverage</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown.Item as={Link} to={`${PREFIX}/amenity`}>Equipment</Dropdown.Item>
                        <Dropdown item text='Calendar'>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to={`${PREFIX}/holidays`}>Holidays</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        {/* <Dropdown.Item as={Link} to={`${PREFIX}/title`}>Event Report Title</Dropdown.Item> */}
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>
            <Menu.Item style={{ minWidth: '200px' }}>
                <Dropdown item text='Report' style={{ width: '100%' }} >
                    <Dropdown.Menu>
                        <Dropdown.Item as={Link} to={`${PREFIX}/eventreport`} >  All Events</Dropdown.Item>
                        <Dropdown.Item as={Link} to={`${PREFIX}/adminreport`} >  Admin Report</Dropdown.Item>
                        <Dropdown.Item as={Link} to={`${PREFIX}/roombyname`} >  Room Usage By Name</Dropdown.Item>
                        <Dropdown.Item as={Link} to={`${PREFIX}/roombytype`} >  Room Usage By Type</Dropdown.Item>
                        <Dropdown.Item as={Link} to={`${PREFIX}/reportbyuser`} >  Report By user </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>
            <Menu.Item style={{ minWidth: '200px' }}>
                <Dropdown item text='Setting' style={{ width: '100%' }} >
                    <Dropdown.Menu>
                        <Dropdown.Item as={Link} to={`${PREFIX}/setting`} >  Global</Dropdown.Item>
                        <Dropdown.Item as={Link} to={`${PREFIX}/term`} >  Term & Conditions</Dropdown.Item>
                        <Dropdown.Item as={Link} to={`${PREFIX}/term/trainingroom`} >  Term & Condition for Training Room</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>
            {/* <Menu.Item as={Link} to={`${PREFIX}/setting`} >
                Setting
            </Menu.Item> */}
            {/* <Menu.Item as={Link} to={`${PREFIX}/eventreport`} >
                Event Report
            </Menu.Item> */}

            {/* <Dropdown item text='Report'>
                <Dropdown.Menu>
                    <Dropdown item text='Users'>
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to={`${PREFIX}/user/local`}>All Local User</Dropdown.Item>
                            <Dropdown.Item as={Link} to={`${PREFIX}/user/sync/create`}>Create Sync User</Dropdown.Item>
                            <Dropdown.Item as={Link} to={`${PREFIX}/`}>User Role</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Dropdown.Menu>
            </Dropdown> */}
            <Menu.Item position='right'>
                <Dropdown item text='Profile'>
                    <Dropdown.Menu>
                        <Dropdown.Item as={Link} to={`${PREFIX}/user/info`}>User Infomation</Dropdown.Item>
                        <Dropdown.Item onClick={logout} >Log Out</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>
        </Menu>
    </Container >
)

const Header = ({ isLoggedIn, logout }) => (
    <div>
        {
            isLoggedIn ? <AuthHeader logout={logout} /> : <NoAuthHeader />
        }
    </div>
)

export default compose(
    withRouter,
    connect(
        state => ({ isLoggedIn: getIsLoggedIn(state) }),
        (dispatch, props) => ({
            logout() {
                dispatch(logout())
            }
        })
    )
)(Header)


// WEBPACK FOOTER //
// ./src/features/ui/components/Header.js